// ============ QUIZ TROUBLES MENSTRUELS - SCRIPT COMPLET ============
(function() {
  // Vérifier si le quiz existe sur cette page
  if (!document.getElementById('quiz-troubles-menstruels')) {
    return; // Sortir si pas de quiz
  }

  console.log('🚀 Quiz troubles menstruels détecté');

  // ========== DONNÉES DU QUIZ (12 QUESTIONS) ==========
  const QUIZ_DATA = [
    {
      id: 1,
      question: "Comment décrirais-tu la régularité de ton cycle menstruel ?",
      type: "single",
      options: [
        { text: "Très régulier (cycle toujours entre 25-35 jours)", value: "regulier", points: {} },
        { text: "Plutôt régulier mais parfois variable (±5 jours)", value: "variable", points: {} },
        { text: "Cycles longs (souvent > 35 jours)", value: "long", points: { oligomenorrhee: 3, sopk: 2, anovulatoire: 1 } },
        { text: "Cycles courts (souvent < 21 jours)", value: "court", points: { polymenorrhee: 3, insuffisance_luteale: 2 } },
        { text: "Règles très rares (1-2 fois par an seulement)", value: "tres_rare", points: { spaniomenorrhee: 5, sopk: 3, amenorrhee: 2 } },
        { text: "Totalement anarchique (impossible à prévoir)", value: "anarchique", points: { sopk: 3, anovulatoire: 2, oligomenorrhee: 1 } },
        { text: "Absence totale de règles depuis 3+ mois", value: "absent", points: { amenorrhee: 5, sopk: 2, anovulatoire: 1 } }
      ]
    },
    {
      id: 2,
      question: "Quelle est l'abondance de tes règles ?",
      type: "single",
      options: [
        { text: "Normale (3-5 protections/jour)", value: "normale", points: {} },
        { text: "Légères (1-2 protections/jour)", value: "legeres", points: { hypomenorrhee: 2 } },
        { text: "Très légères (quelques gouttes, protège-slip suffit)", value: "tres_legeres", points: { hypomenorrhee: 4, sopk: 1 } },
        { text: "Abondantes (change toutes les 2-3h, caillots)", value: "abondantes", points: { menorragie: 3, fibromes: 2, adenomyose: 2 } },
        { text: "Hémorragiques (change toutes les heures, caillots énormes)", value: "hemorragiques", points: { menorragie: 5, fibromes: 3, adenomyose: 3 } }
      ]
    },
    {
      id: 3,
      question: "Combien de temps durent tes règles ?",
      type: "single",
      options: [
        { text: "2-3 jours", value: "court", points: { hypomenorrhee: 1 } },
        { text: "4-7 jours (normal)", value: "normal", points: {} },
        { text: "8-10 jours", value: "long", points: { menorragie: 2, fibromes: 2, adenomyose: 1 } },
        { text: "Plus de 10 jours", value: "tres_long", points: { menorragie: 3, fibromes: 3, adenomyose: 2 } }
      ]
    },
    {
      id: 4,
      question: "As-tu des saignements en dehors de tes règles ?",
      type: "single",
      options: [
        { text: "Jamais", value: "jamais", points: {} },
        { text: "Rarement (spotting 1-2x/an)", value: "rare", points: {} },
        { text: "Spotting au milieu du cycle (ovulation)", value: "ovulation", points: {} },
        { text: "Spotting avant les règles", value: "avant_regles", points: { insuffisance_luteale: 2, fibromes: 1 } },
        { text: "Saignements fréquents entre les règles", value: "frequent", points: { metrorragie: 4, fibromes: 2, polypes: 2 } }
      ]
    },
    {
      id: 5,
      question: "À quel point tes règles sont-elles douloureuses ?",
      type: "single",
      options: [
        { text: "Pas de douleur ou très légère", value: "legere", points: {} },
        { text: "Douleur modérée mais gérable", value: "moderee", points: {} },
        { text: "Douleur forte (besoin d'antalgiques)", value: "forte", points: { dysmenorrhee: 2 } },
        { text: "Douleur invalidante (je ne peux pas me lever)", value: "invalidante", points: { dysmenorrhee: 4, endometriose: 3, adenomyose: 2 } },
        { text: "Douleur qui empire avec le temps", value: "empire", points: { endometriose: 5, adenomyose: 3 } }
      ]
    },
    {
      id: 6,
      question: "As-tu des douleurs pelviennes en dehors des règles ?",
      type: "multiple",
      options: [
        { text: "Non, jamais", value: "non", points: {} },
        { text: "Douleurs pendant les rapports sexuels", value: "rapports", points: { endometriose: 4, adenomyose: 2 } },
        { text: "Douleurs à la défécation pendant les règles", value: "defecation", points: { endometriose: 4 } },
        { text: "Douleurs à la miction pendant les règles", value: "miction", points: { endometriose: 3 } },
        { text: "Douleurs pelviennes chroniques", value: "chronique", points: { endometriose: 4, adenomyose: 3, fibromes: 2 } }
      ]
    },
    {
      id: 7,
      question: "Comment te sens-tu dans la semaine AVANT tes règles ?",
      type: "multiple",
      options: [
        { text: "Normale, pas de changement particulier", value: "normale", points: {} },
        { text: "Seins douloureux et gonflés", value: "seins", points: { spm: 2 } },
        { text: "Ballonnements, rétention d'eau", value: "ballonnements", points: { spm: 2 } },
        { text: "Irritable, sautes d'humeur", value: "irritable", points: { spm: 2, tdpm: 1 } },
        { text: "Fatigue intense, envie de dormir tout le temps", value: "fatigue", points: { spm: 2 } },
        { text: "Anxiété majeure, crises d'angoisse", value: "anxiete", points: { spm: 1, tdpm: 3 } },
        { text: "Dépression intense, pensées noires/suicidaires", value: "depression", points: { tdpm: 5 } },
        { text: "Colère explosive incontrôlable", value: "colere", points: { tdpm: 4 } }
      ]
    },
    {
      id: 8,
      question: "Ces symptômes avant les règles t'empêchent-ils de fonctionner normalement ?",
      type: "single",
      options: [
        { text: "Non, c'est gérable", value: "gerable", points: {} },
        { text: "Un peu gênant mais je gère", value: "genant", points: { spm: 1 } },
        { text: "Je dois adapter mes activités", value: "adapter", points: { spm: 2, tdpm: 1 } },
        { text: "Je rate le travail/les cours", value: "rate_travail", points: { spm: 3, tdpm: 3 } },
        { text: "Je ne peux plus fonctionner du tout (travail, relations, vie sociale)", value: "handicapant", points: { tdpm: 5 } }
      ]
    },
    {
      id: 9,
      question: "As-tu des symptômes cutanés ou de pilosité ?",
      type: "multiple",
      options: [
        { text: "Non, rien de particulier", value: "non", points: {} },
        { text: "Acné modérée", value: "acne_moderee", points: {} },
        { text: "Acné sévère (visage, dos, torse)", value: "acne_severe", points: { sopk: 2, hyperandrogenie: 3 } },
        { text: "Pilosité excessive (visage, ventre, torse)", value: "pilosite", points: { sopk: 3, hyperandrogenie: 4 } },
        { text: "Perte de cheveux sur le sommet du crâne", value: "alopecie", points: { sopk: 2, hyperandrogenie: 3 } },
        { text: "Peau et cheveux très gras", value: "gras", points: { sopk: 1 } }
      ]
    },
    {
      id: 10,
      question: "As-tu des difficultés avec ton poids ?",
      type: "single",
      options: [
        { text: "Non, poids stable", value: "stable", points: {} },
        { text: "Prise de poids inexpliquée et difficile à perdre", value: "prise", points: { sopk: 2 } },
        { text: "Perte de poids rapide récente", value: "perte", points: { amenorrhee: 2, anovulatoire: 1 } },
        { text: "Variations importantes de poids", value: "variations", points: { sopk: 1 } }
      ]
    },
    {
      id: 11,
      question: "Essaies-tu de tomber enceinte ou as-tu des difficultés de fertilité ?",
      type: "single",
      options: [
        { text: "Je n'essaie pas / pas de projet bébé", value: "non", points: {} },
        { text: "J'essaie depuis moins de 6 mois", value: "essai_court", points: {} },
        { text: "J'essaie depuis 6-12 mois sans succès", value: "essai_moyen", points: { anovulatoire: 2, insuffisance_luteale: 2, sopk: 1 } },
        { text: "J'essaie depuis plus d'un an sans succès", value: "essai_long", points: { anovulatoire: 3, sopk: 3, endometriose: 2 } },
        { text: "J'ai fait des fausses couches précoces répétées", value: "fausses_couches", points: { insuffisance_luteale: 4, endometriose: 2 } }
      ]
    },
    {
      id: 12,
      question: "Quel âge as-tu ?",
      type: "single",
      options: [
        { text: "Moins de 16 ans (règles pas encore arrivées)", value: "moins_16", points: { amenorrhee_primaire: 3 } },
        { text: "16-25 ans", value: "16_25", points: {} },
        { text: "26-35 ans", value: "26_35", points: {} },
        { text: "36-45 ans", value: "36_45", points: { adenomyose: 1, fibromes: 1 } },
        { text: "Plus de 45 ans", value: "plus_45", points: { adenomyose: 2, fibromes: 2 } }
      ]
    }
  ];

  // ========== INFORMATIONS SUR LES TROUBLES ==========
  const TROUBLES_INFO = {
    amenorrhee: { nom: "Aménorrhée", desc: "Absence de règles pendant 3 mois ou plus", gravite: "Variable", action: "Faire un test de grossesse puis consulter pour bilan hormonal (FSH, LH, prolactine, thyroïde)", couleur: "#FFB74D" },
    oligomenorrhee: { nom: "Oligoménorrhée", desc: "Cycles très espacés (> 35 jours)", gravite: "Faible", action: "Tenir un journal de cycle, consulter si projet bébé ou si accompagné d'autres symptômes", couleur: "#9CCC65" },
    spaniomenorrhee: { nom: "Spanioménorrhée", desc: "Règles très rares (seulement 1-2 fois par an)", gravite: "Moyenne", action: "Consulter pour bilan hormonal - Peut être lié au SOPK ou à d'autres troubles hormonaux", couleur: "#FF9800" },
    polymenorrhee: { nom: "Polyménorrhée", desc: "Cycles trop courts (< 21 jours)", gravite: "Faible", action: "Bilan thyroïdien, traitement par progestatifs si gênant", couleur: "#9CCC65" },
    hypomenorrhee: { nom: "Hypomenorrhée", desc: "Règles très faibles (quelques gouttes seulement)", gravite: "Faible", action: "Observer sur plusieurs cycles, consulter si accompagné d'autres symptômes ou si gênant", couleur: "#9CCC65" },
    menorragie: { nom: "Ménorragie", desc: "Règles très abondantes et/ou prolongées", gravite: "Moyenne", action: "Consulter rapidement - Bilan sanguin (fer, ferritine) + échographie pelvienne", couleur: "#FF9800" },
    metrorragie: { nom: "Métrorragie", desc: "Saignements en dehors des règles", gravite: "Variable", action: "Consulter si répété - Frottis + échographie + bilan infectieux", couleur: "#FFB74D" },
    dysmenorrhee: { nom: "Dysménorrhée", desc: "Règles très douloureuses", gravite: "Moyenne", action: "AINS (ibuprofène) dès le début, consulter pour écarter endométriose si invalidant", couleur: "#FF9800" },
    spm: { nom: "Syndrome Prémenstruel (SPM)", desc: "Symptômes physiques et émotionnels avant les règles", gravite: "Faible", action: "Calcium 1000mg/j, magnésium+B6, gattilier, activité physique", couleur: "#9CCC65" },
    tdpm: { nom: "Trouble Dysphorique Prémenstruel (TDPM)", desc: "Dépression sévère, pensées suicidaires avant les règles", gravite: "Élevée", action: "CONSULTER EN URGENCE - Traitement par ISRS (antidépresseurs) très efficace", couleur: "#EF5350" },
    endometriose: { nom: "Endométriose", desc: "Tissu endométrial hors de l'utérus, très douloureux", gravite: "Élevée", action: "Consulter gynéco spécialisé endométriose - IRM + éventuellement cœlioscopie", couleur: "#EF5350" },
    adenomyose: { nom: "Adénomyose", desc: "Tissu endométrial dans le muscle utérin", gravite: "Moyenne", action: "IRM pour diagnostic, stérilet hormonal ou autres traitements", couleur: "#FF9800" },
    sopk: { nom: "Syndrome des Ovaires Polykystiques (SOPK)", desc: "Dérèglement hormonal avec cycles irréguliers + acné + pilosité", gravite: "Moyenne", action: "Bilan hormonal complet (testostérone, LH/FSH, glycémie) + échographie ovarienne", couleur: "#FF9800" },
    anovulatoire: { nom: "Cycles Anovulatoires", desc: "Absence d'ovulation malgré des saignements", gravite: "Faible", action: "Bilan si projet bébé, inducteurs d'ovulation si nécessaire", couleur: "#9CCC65" },
    insuffisance_luteale: { nom: "Insuffisance Lutéale", desc: "Phase après ovulation trop courte", gravite: "Faible", action: "Dosage progestérone, supplémentation si projet bébé ou fausses couches", couleur: "#9CCC65" },
    hyperandrogenie: { nom: "Hyperandrogénie", desc: "Excès d'hormones masculines (acné sévère, pilosité)", gravite: "Moyenne", action: "Bilan hormonal, pilule anti-androgénique (Diane 35, Jasmine)", couleur: "#FF9800" },
    fibromes: { nom: "Fibromes Utérins", desc: "Tumeurs bénignes dans l'utérus", gravite: "Faible à Moyenne", action: "Échographie pour diagnostic, surveillance ou traitement selon symptômes", couleur: "#9CCC65" },
    polypes: { nom: "Polypes Utérins", desc: "Excroissances bénignes dans l'utérus", gravite: "Faible", action: "Échographie + hystéroscopie si nécessaire", couleur: "#9CCC65" },
    amenorrhee_primaire: { nom: "Aménorrhée Primaire", desc: "Règles qui n'ont jamais démarré à 16 ans", gravite: "Nécessite investigation", action: "CONSULTER - Bilan hormonal et anatomique complet", couleur: "#FF9800" }
  };

  // ========== VARIABLES GLOBALES ==========
  let currentQuestionIndex = 0;
  let userAnswers = {};

  // ========== RÉCUPÉRATION DES ÉLÉMENTS DOM ==========
  const questionContainer = document.getElementById('quiz-container');
  const progressBar = document.getElementById('quiz-progress-bar');
  const progressText = document.getElementById('quiz-progress-text');
  const progressPercent = document.getElementById('quiz-progress-percent');
  const btnPrev = document.getElementById('quiz-prev-btn');
  const btnNext = document.getElementById('quiz-next-btn');
  const btnSubmit = document.getElementById('quiz-submit-btn');
  const resultsDiv = document.getElementById('quiz-results');
  const quizDiv = document.getElementById('quiz-troubles-menstruels');

  // ========== FONCTION : AFFICHER UNE QUESTION ==========
  function showQuestion(index) {
    const question = QUIZ_DATA[index];
    let html = '<div style="animation: fadeIn 0.3s ease;"><h3 style="color: #6b4e5c; font-size: 1.2em; margin-bottom: 20px; font-weight: 600;">' + question.question + '</h3>';

    if (question.type === 'single') {
      question.options.forEach(function(option) {
        const isChecked = userAnswers[question.id] === option.value ? 'checked' : '';
        html += '<label style="display: block; background: white; padding: 15px 18px; margin-bottom: 12px; border-radius: 8px; cursor: pointer; border: 2px solid ' + (isChecked ? '#c994b5' : '#f0e5eb') + '; transition: all 0.3s;"><input type="radio" name="q' + question.id + '" value="' + option.value + '" ' + isChecked + ' style="margin-right: 10px;"><span style="line-height: 1.6; color: #4a4a4a;">' + option.text + '</span></label>';
      });
    } else {
      html += '<p style="color: #9d6b88; font-size: 0.9em; margin-bottom: 15px; font-style: italic;">Plusieurs réponses possibles</p>';
      question.options.forEach(function(option) {
        const isChecked = userAnswers[question.id] && userAnswers[question.id].indexOf(option.value) > -1 ? 'checked' : '';
        html += '<label style="display: block; background: white; padding: 15px 18px; margin-bottom: 12px; border-radius: 8px; cursor: pointer; border: 2px solid ' + (isChecked ? '#c994b5' : '#f0e5eb') + '; transition: all 0.3s;"><input type="checkbox" name="q' + question.id + '" value="' + option.value + '" ' + isChecked + ' style="margin-right: 10px;"><span style="line-height: 1.6; color: #4a4a4a;">' + option.text + '</span></label>';
      });
    }

    html += '</div>';
    questionContainer.innerHTML = html;

    // Attacher événements
    const inputs = questionContainer.querySelectorAll('input');
    inputs.forEach(function(input) {
      input.addEventListener('change', function() {
        if (question.type === 'single') {
          userAnswers[question.id] = this.value;
        } else {
          if (!userAnswers[question.id]) userAnswers[question.id] = [];
          const idx = userAnswers[question.id].indexOf(this.value);
          if (this.checked && idx === -1) {
            userAnswers[question.id].push(this.value);
          } else if (!this.checked && idx > -1) {
            userAnswers[question.id].splice(idx, 1);
          }
        }
        updateBorders();
      });
    });

    updateProgress();
    updateButtons();
  }

  function updateBorders() {
    const labels = questionContainer.querySelectorAll('label');
    labels.forEach(function(label) {
      const input = label.querySelector('input');
      if (input && input.checked) {
        label.style.borderColor = '#c994b5';
      } else if (input) {
        label.style.borderColor = '#f0e5eb';
      }
    });
  }

  function updateProgress() {
    const progress = ((currentQuestionIndex + 1) / QUIZ_DATA.length) * 100;
    progressBar.style.width = progress + '%';
    progressText.textContent = 'Question ' + (currentQuestionIndex + 1) + ' / ' + QUIZ_DATA.length;
    progressPercent.textContent = Math.round(progress) + '%';
  }

  function updateButtons() {
    btnPrev.style.display = currentQuestionIndex > 0 ? 'block' : 'none';
    btnNext.style.display = currentQuestionIndex < QUIZ_DATA.length - 1 ? 'block' : 'none';
    btnSubmit.style.display = currentQuestionIndex === QUIZ_DATA.length - 1 ? 'block' : 'none';
  }

  function nextQuestion() {
    if (currentQuestionIndex < QUIZ_DATA.length - 1) {
      currentQuestionIndex++;
      showQuestion(currentQuestionIndex);
    }
  }

  function prevQuestion() {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex--;
      showQuestion(currentQuestionIndex);
    }
  }

  function showResults() {
    const scores = {};

    QUIZ_DATA.forEach(function(question) {
      const answer = userAnswers[question.id];
      if (!answer) return;

      if (Array.isArray(answer)) {
        answer.forEach(function(val) {
          const opt = question.options.find(function(o) { return o.value === val; });
          if (opt && opt.points) {
            Object.keys(opt.points).forEach(function(trouble) {
              scores[trouble] = (scores[trouble] || 0) + opt.points[trouble];
            });
          }
        });
      } else {
        const opt = question.options.find(function(o) { return o.value === answer; });
        if (opt && opt.points) {
          Object.keys(opt.points).forEach(function(trouble) {
            scores[trouble] = (scores[trouble] || 0) + opt.points[trouble];
          });
        }
      }
    });

    // Filtrage : max 3 résultats, minimum 5 points, 60% du score principal
    const allTroubles = [];
    for (var t in scores) {
      allTroubles.push([t, scores[t]]);
    }
    allTroubles.sort(function(a, b) { return b[1] - a[1]; });

    const filtered = [];
    if (allTroubles.length > 0 && allTroubles[0][1] >= 5) {
      const maxScore = allTroubles[0][1];
      const threshold = maxScore * 0.6;
      for (var i = 0; i < allTroubles.length && filtered.length < 3; i++) {
        if (allTroubles[i][1] >= 5 && allTroubles[i][1] >= threshold) {
          filtered.push(allTroubles[i]);
        }
      }
    }

    displayResults(filtered);
  }

  function displayResults(troubles) {
    quizDiv.style.display = 'none';
    resultsDiv.style.display = 'block';

    let html = '<div style="background: linear-gradient(135deg, #f5f8f5 0%, #edf2ed 100%); padding: 30px; border-radius: 12px; border-left: 5px solid #7fa87f;"><h3 style="color: #5d7a5d; margin-top: 0; font-weight: 600; font-size: 1.5em; margin-bottom: 20px;">📊 Tes Résultats</h3>';

    if (troubles.length === 0) {
      html += '<div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 15px;"><p style="line-height: 1.7; color: #4a4a4a; margin: 0;"><strong style="color: #5d7a5d;">Bonne nouvelle !</strong><br>Tes réponses ne correspondent pas à un trouble menstruel spécifique. Si tu as quand même des symptômes qui te gênent, n\'hésite pas à consulter un gynécologue pour un avis personnalisé.</p></div>';
    } else {
      html += '<p style="line-height: 1.7; color: #4a4a4a; margin-bottom: 20px;">Selon tes réponses, voici le(s) trouble(s) qui correspond(ent) le mieux à tes symptômes :</p>';

      troubles.forEach(function(item, index) {
        const troubleKey = item[0];
        const score = item[1];
        const info = TROUBLES_INFO[troubleKey];
        if (!info) return;

        const percentage = Math.min(100, (score / 15) * 100);

        html += '<div style="background: white; padding: 20px; border-radius: 8px; margin-bottom: 15px; border-left: 4px solid ' + info.couleur + ';"><div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px; flex-wrap: wrap; gap: 10px;"><h4 style="color: #6b4e5c; margin: 0; font-size: 1.2em; font-weight: 600;">' + (index === 0 ? '🎯 ' : '') + info.nom + '</h4><span style="background: ' + info.couleur + '; color: white; padding: 5px 12px; border-radius: 15px; font-size: 0.85em; font-weight: 600;">Correspondance : ' + Math.round(percentage) + '%</span></div><p style="line-height: 1.7; color: #4a4a4a; margin: 10px 0; font-style: italic;">' + info.desc + '</p><div style="background: #f9f9f9; padding: 12px 15px; border-radius: 6px; margin-top: 12px;"><p style="margin: 0 0 5px 0; font-weight: 600; color: #6b4e5c; font-size: 0.95em;">Gravité : <span style="color: ' + info.couleur + ';">' + info.gravite + '</span></p><p style="margin: 0; line-height: 1.6; color: #4a4a4a; font-size: 0.95em;"><strong>Action recommandée :</strong> ' + info.action + '</p></div></div>';
      });
    }

    html += '<div style="background: #fff9f9; padding: 18px; border-left: 4px solid #d97575; border-radius: 8px; margin-top: 25px;"><p style="font-weight: 600; color: #b85f5f; margin: 0 0 8px 0;">⚠️ Important</p><p style="line-height: 1.7; color: #4a4a4a; margin: 0; font-size: 0.95em;">Ces résultats sont <strong>indicatifs uniquement</strong>. Seul un médecin peut poser un diagnostic fiable après examen clinique et examens complémentaires. Si tes symptômes impactent ta qualité de vie, consulte un gynécologue sans attendre.</p></div><div style="text-align: center; margin-top: 25px;"><button onclick="location.reload()" style="background: linear-gradient(135deg, #c994b5 0%, #b482a2 100%); color: white; padding: 12px 28px; border: none; border-radius: 25px; font-weight: 600; font-size: 1em; cursor: pointer; box-shadow: 0 3px 12px rgba(201, 148, 181, 0.3);">🔄 Refaire le quiz</button></div></div>';

    resultsDiv.innerHTML = html;
    resultsDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // ========== ATTACHER LES ÉVÉNEMENTS ==========
  btnNext.addEventListener('click', function(e) { e.preventDefault(); nextQuestion(); });
  btnPrev.addEventListener('click', function(e) { e.preventDefault(); prevQuestion(); });
  btnSubmit.addEventListener('click', function(e) { e.preventDefault(); showResults(); });

  // ========== INITIALISATION ==========
  showQuestion(0);
  console.log('✅ Quiz initialisé');
})();
